"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectLinkPreviewIsEnabledOption')(function selectLinkPreviewIsEnabledOption(isLinkPreviewEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isLinkPreviewEnabled;
}));
//# sourceMappingURL=selectLinkPreviewIsEnabledOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-link-preview-option/lib/actions/selectLinkPreviewIsEnabledOption.js
// module id = 5142
// module chunks = 2